import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';

// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../../scss/components/StyleSelectorConfiguration.module.scss';

import { ProductStyleConfigurationCMS } from './types';

const cssModulesClassNames = withCssModulesClassNames(styles);

export interface ConfigurationProps {
  configuration: Pick<ProductStyleConfigurationCMS, 'icon' | 'label'>;
  isActive: boolean;
  onClick: () => void;
}
const Configuration = ({
  configuration: { icon, label },
  isActive,
  onClick,
}: ConfigurationProps) => (
  <div
    role="button"
    aria-label={label}
    onClick={() => (!isActive && onClick())}
    className={cssModulesClassNames('style-configurations__configuration', {
      'style-configurations__configuration--is-selected': isActive,
    })}
  >
    <img src={icon.url} alt={''} />
  </div>
);

export default Configuration;
